// extracted by mini-css-extract-plugin
module.exports = {"button":"Tabs_button__2jemh","active":"Tabs_active__FvpRL"};